import withIcon from './NewIcon';
// @ts-ignore
import IconList from './icon/m/list.s.svg';

export default withIcon(IconList);
